import { useQuery } from "@tanstack/react-query";

const fetchTeam = async (id) => {
	const response = await fetch(`/api/team/${id}`, {
		method: "GET",
	});

	if (!response.ok) {
		throw new Error("Could Not Fetch Team Data");
	}

	return response.json();
};

export const useTeam = (id) => {
	return useQuery({
		queryKey: ["teamData"],
		queryFn: async () => fetchTeam(id),
		refetchOnWindowFocus: false,
		enabled: true,
	});
};

const fetchConf = async (id) => {
	let resp;
	if (id === undefined) {
		resp = await fetch(`/api/conf`, {
			method: "GET",
		});
	} else {
		resp = await fetch(`/api/conf/${id}`, {
			method: "GET",
		});
	}
	if (!resp.ok) {
		throw new Error("Could Not Fetch Conf Data");
	}

	return resp.json();
};

export const getConf = (id) => {
	return useQuery({
		queryKey: ["confData", id],
		queryFn: async () => fetchConf(id),
		refetchOnWindowFocus: false,
		enabled: true,
	});
};

const fetchDiv = async (id) => {
	let resp;
	if (id === undefined) {
		resp = await fetch(`/api/division`, {
			method: "GET",
		});
	} else {
		resp = await fetch(`/api/division/${id}`, {
			method: "GET",
		});
	}

	if (!resp.ok) {
		throw new Error("Could Not Fetch Division Data");
	}

	return resp.json();
};

export const getDiv = (id) => {
	return useQuery({
		queryKey: ["divisionData", id],
		queryFn: async () => fetchDiv(id),
		refetchOnWindowFocus: false,
		enabled: true,
	});
};
